<template>
    <section v-if="pastimesListPage" class="pastimes-section-wrapper" :class="{ 'vw-100 p-0' : isDesktop, 'mobile-wrapper' : !isDesktop, 'legacy-scroll-bar-support' : legacyCustomScrollBar }">
        <div v-if="pastimesBlocks" class="m-0 submissions-display-wrapper">
            <div v-for="(blocklist, index) in pastimesBlocks.config" class="general-block-wrapper" :class="{ 'full-vw' : isDesktop }">
                <HomeBlocks v-for="config in blocklist" :key="'pageBlock-' + index" :is-desktop="isDesktop" :config="config" :border-width="6" :url="pastimesBlocks.url"/>
            </div>
        </div>
    </section>
    <section v-else-if="pastimeInfo" class="pastimes-section-wrapper" :class="{ 'mobile-wrapper' : !isDesktop, 'legacy-scroll-bar-support' : legacyCustomScrollBar }">
        <!-- this will be 3 different pages contestant (pastime main page, voting/registration, participants page (mobile only)) -->
        <div v-if="contestantPage" class="w-100" :class="{'boxpad': isDesktop}" >
            <ContestantSection 
                @load-registration="loadRegistrationData(urls.registrationUrl)"
            />
        </div>    
        <section v-else-if="(participantListPage || rankingPage)" class="participants-page-wrapper" style="width: 100%">
            <div :class="{'boxpad': isDesktop}">
                <ParticipantsList
                    :isRanking="rankingPage"
                />
            </div>    
        </section>
        <section v-else class="contestants-ranking-wrapper">
            <div :class="{'order-0' : !isDesktop, 'boxpad': isDesktop}">
                <ParticipationHeader
                    :img-url="banner"
                    :title="pastimeInfo.baseInfo.name"
                    :description="pastimeDescription"
                    :button-text="mainButtonText"
                    :enabled="enableRegistration || enableGoToSubmission"
                    :action-type="'link'"
                    :participation-warning="participationWarning"
                    @link="!hasRegistered ? loadRegistrationData(urls.registrationUrl) : goToLink(urls.customerSubmissionUrl)"
                    @see-faqs="modalControl(true, 'faqs')"
                    @see-rules="modalControl(true, 'rules')"
                />
            </div>
            <!-- single home block slide -> to be component -->
            <div v-if="urls && rankingBlock" class="general-block-wrapper ranking-lock-wrapper" :class="{ 'order-1' : !isDesktop, 'full-vw' : isDesktop }"> 
                <HomeBlocks :is-desktop="isDesktop" :config="rankingBlock.config" :url="rankingBlock.url" :border-width="6" :relative-viewport="true"/>
            </div>
            <!-- general item display list -> to be component -->
            <ParticipantsList v-if="isDesktop && participants" :class="{'order-2': true, 'boxpad': isDesktop}"
                :show-title="true"              
            />
            <div v-else-if="recentBlock" class="general-block-wrapper" :class="{ 'full-vw' : isDesktop, 'order-2' : !isDesktop }">
                <HomeBlocks :is-desktop="isDesktop" :config="recentBlock.config" :url="recentBlock.url"/>
            </div>
        </section>
        <div :class="{'boxpad': isDesktop, 'w-100': !isDesktop }">
            <h2 v-if="!contestantPage && !participants" class="pastime-notice">
                {{ kStrings.kNO_PARTICIPANTS_REGISTRATION }}
            </h2>
        </div>    
        <div v-if="contestantPage" class="w-100 mx-0" :class="{ 'row justify-content-between' : isDesktop, 'faq-rules': !isDesktop, 'boxpad':isDesktop }">
            <ParticipationInfo 
                :title="kStrings.kQUESTIONS_AND_ANSWERS" 
                :description="kStrings.kQUESTIONS_AND_ANSWERS_DESCRIPTION" 
                :button-text="'FAQ'"
                :class="[ isDesktop ? 'grid-mode' : 'my-4' ]"
                @modal-status="modalControl(true, 'faqs')"
            />
            <ParticipationInfo
                :title="kStrings.kRULES"
                :description="kStrings.kREGULATION_DESCRIPTION"
                :button-text="kStrings.kREGULATION"
                :class="{ 'grid-mode' : isDesktop }"
                @modal-status="modalControl(true, 'rules')"
            />
        </div>
        <section v-if="showActivePastimesBlocks && ongoingBlocks" class="submissions-display-wrapper">
            <div v-for="blocklist in ongoingBlocks.config" class="general-block-wrapper" :class="{ 'full-vw' : isDesktop }">
                <HomeBlocks v-for="(config, index) in blocklist" :key="'ongoing-' + index" :is-desktop="isDesktop" :config="config" :border-width="6" :url="ongoingBlocks.url"/>
            </div>
        </section>
        <section v-if="bannerBlocks" class="submissions-display-wrapper">
            <HomeBlocks :is-desktop="isDesktop" :config="bannerBlocks.config" :border-width="6" :url="bannerBlocks.url"/>
        </section>
        <MuffinLoader v-if="isLoading" class="full-page"/>
        <!-- general content modal -->
        <GeneralModal v-if="modalStatus"/>
    </section>
</template>

<script>

import HomeBlocks from "@/components/Home/Common/HomeBlocks";
import LoadImageLazy from '@/components/LoadImageLazy';

import ContestantSection from '@/components/Pastimes/Desktop/sections/ContestantSection';
import ParticipantsList from '@/components/Pastimes/Desktop/sections/ParticipantsList';
import GeneralModal from '@/components/Pastimes/Desktop/partials/GeneralModal';
import ParticipationInfo from '@/components/Pastimes/Desktop/partials/ParticipationInfo';

import MuffinLoader from '@/components/Muffin/Loader';

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
import request from '@/Utilities/httpRequest';
import browser from '@/Utilities/browser'
import ParticipationHeader from '@/components/Pastimes/Desktop/partials/ParticipationHeader.vue';

export default {
    store,
    name: 'Index',
    components: {
        ParticipationHeader,
        HomeBlocks,
        LoadImageLazy,
        ContestantSection,
        ParticipantsList,
        ParticipationInfo,
        GeneralModal,
        MuffinLoader
    },
    props: {
        devMode: {
            type: Boolean,
            default: false  
        },
        pastimesPageData: null, // pastimes "catalog" list
        detailsData: null,
        participantData: null
    },
    data() {
        return {
            legacyCustomScrollBar: false
        }
    },
    computed: {
        isLogged() {
            return this.$store.getters.isLogged;
        },
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        urls() {
            return this.$store.getters.urls;
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        pastimesListPage() {
            let activePage = this.$store.getters.activePage
            return activePage ? activePage == 'pastimes-page' : null;
        },
        contestantPage() {
            let activePage = this.$store.getters.activePage 
            return activePage ? activePage == 'voting' || activePage == 'registration' : null;
        },
        participantListPage() {
            let activePage = this.$store.getters.activePage
            return activePage ? activePage == 'participants-list' : null;
        },
        rankingPage() {
            let activePage = this.$store.getters.activePage
            return activePage ? activePage == 'ranking' : null;
        },
        modalStatus() {
            return this.$store.getters.modalStatus;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        contestId() {
            return this.$store.getters.contestId;
        },
        banner() {
            if(isEmpty(this.$store.getters.banner)) {
                return null;
            }
            
            return this.$store.getters.banner;
        },
        rules() {
            return this.$store.getters.rules;
        },
        participants() {
            return !isEmpty(this.$store.getters.participants) ? this.$store.getters.participants : null;
        },
        pagination() {
            return this.$store.getters.pagination;  
        },
        rankingBlock() {
            return this.$store.getters.rankingBlock;
        },
        recentBlock() { // for mobile only
            if(this.isDesktop || !this.participants) {
                return null;
            }
            
            return this.$store.getters.recentBlock;
        },
        ongoingBlocks() {
            return this.$store.getters.ongoingBlocks;
        },
        pastimesBlocks() {
            return this.$store.getters.pastimesBlocks;
        },
        bannerBlocks() {
            return this.$store.getters.bannerBlocks;
        },
       /* showBottomFaqsAndRules() {
            return this.$store.getters.activePage && (this.$store.getters.activePage == 'registration' || this.$store.getters.activePage == 'voting');
        },*/
        showActivePastimesBlocks() {
            return (!this.$store.getters.activePage || this.$store.getters.activePage == 'voting') && !isEmpty(this.ongoingBlocks);
        },
        registerValidation(){
            return this.$store.getters.registerValidation;
        },
        enableRegistration() {
            // ws now returns an object with proper validations
            // maybe it's best to do this on backend
            let canRegister = this.registerValidation.canRegister;
            return canRegister && !this.hasEnded && !this.hasRegistered;
        },
        hasEnded() {
            return this.pastimeInfo.detailedInfo.hasEnded;
        },
        hasRegistered() {
            return this.registerValidation.alreadyRegistered ?? false; 
        },
        // currentPhase() {
        //     return this.pastimeInfo.detailedInfo.currentPhase;
        // },
        pastimeDescription() {
            //return !this.hasEnded ? this.$store.getters.pastimeDescriptionContent : this.kStrings.kGIVEAWAY_STATUS_ENDED;
            return this.$store.getters.pastimeDescriptionContent;
        },
        mainButtonText() {
           /* if(!this.isLogged && !this.hasEnded) {
                return this.kStrings.kPARTICIPATE;
            }*/
            
            if(this.customerSubmissonDetails && this.customerSubmissonDetails.isPending) {
                return this.kStrings.kREGISTRATION_SUBMITTED;
            }
            
            if(this.customerSubmissonDetails && this.customerSubmissonDetails.isBlacklisted) {
                return this.kStrings.kPASTIME_REGISTRATION_REJECTED;
            }
            
            if(this.hasRegistered) {
                return this.kStrings.kGO_TO_REGISTRATION;
            }
            
            return this.kStrings.kPARTICIPATE;
        },
        // customer susmission details (if exist)
        customerSubmissonDetails() {
            return !isEmpty(this.$store.getters.customerRegistrationInfo) ? this.$store.getters.customerRegistrationInfo : null;
        },
        enableGoToSubmission() {
            if(!this.isLogged && !this.hasEnded) {
                return true;
            }
            
            if(!this.customerSubmissonDetails || !this.customerSubmissonDetails.isApproved) {
                return false;
            }
            
            return this.customerSubmissonDetails.isApproved;
        },
        // warning messages 
        submissionInApprovalState() {
            if(!this.customerSubmissonDetails) {
                return null
            }
            
            if(this.customerSubmissonDetails.isPending) {
                return this.warningStruct(this.kStrings.kPASTIME_REGISTRATION_NOT_VALIDATED,this.kStrings.kINSCRIPTION_IN_VALIDATION);
            }
            
            return null;

        },
        cantRegisterMotive() {
            if(this.enableRegistration) {
                return null;
            }

            let motive = this.registerValidation?.motive ?? this.kStrings.kCANT_REGISTER_PASTIME_FOR_NOW;
            return this.warningStruct(null,motive);
        },
        participationWarning() {
            if(this.hasEnded) {
                return this.warningStruct(null,this.kStrings.kGIVEAWAY_STATUS_ENDED);
            }

            if(!this.isLogged){
                return null;
            }

            if(this.enableGoToSubmission){
                return null;
            }
            
            return this.submissionInApprovalState ? this.submissionInApprovalState : this.cantRegisterMotive;
        }
    },
    watch: {},
    created() {},
    mounted() {
        this.$nextTick(() => {
            if(this.pastimesPageData) {
                this.$store.dispatch('setPastimesListPage', this.pastimesPageData);
            } else if(this.detailsData) { // base page
                this.$store.dispatch('setWsData', this.detailsData);
            } else if(this.participantData) {
                // participant voting / registration page, fills some base details too
                this.$store.dispatch('contestantPage/setWsData', this.participantData);
            }
            this.legacyCustomScrollBar = this.isDesktop && browser.isFirefox();
        });
    },
    methods: {
        async loadRegistrationData(url = null, redirect = false) {
            if(this.isLogged) {
                if(this.devMode) {
                    const data = await request.get(url,null,false);
                    // clear /participation registration info (dev mode)
                    this.$store.dispatch('contestantPage/setRegistrationInfo', null);
                    this.$store.dispatch('registrationPage/setWsData', data.data);
                } else {
                    this.goToLink(url);
                }
            } else {
                if(this.isDesktop) {
                    // update history so that back button works
//                    windows.history.push();
                    accountAuth.openLogin();
                } else {
                    this.goToLink(this.urls.login);
                }
            }
        },
        warningStruct(pop,msg){
            return {
                popupMsg: pop,
                warningMsg:  msg
            }
        },
        goToLink(link) {
            if(link) {
                window.location.assign(link);
            }
        },
        modalControl(status = false, context = '') {
            this.$store.dispatch('setModalStatus', {status: status, context: context});
        },
    }
};
</script>

<style scoped>

</style>
